export const SENT_OK = 'sent-ok';
export const SENT_FAILURE = 'sent-failure';
export const INITIAL = 'initial';

export const initialState = () => {
    return {
        name: {
            value: '',
            errors: []
        },
        email: {
            value: '',
            errors: []
        },
        phone: {
            value: '',
            errors: []
        },
        number: {
            value: '',
            errors: []
        },
        company: {
            value: '',
            errors: []
        },
        question: {
            value: '',
            errors: []
        },
        gdprChecked: {
            value: false,
            errors: []
        },
        sentStatus: INITIAL,
    }
};




// WEBPACK FOOTER //
// ./src/components/company/askus/AskUsState.js